export default __webpack_public_path__ + "static/media/EY.fad865cb.svg";